/**
 * Prefix a url with https if it isn't already
 *
 * @param url - A URL string to prefix
 * @returns Prefixed url
 */
const getSiteUrl = (url: string): string => {
  if (!url.match(/^https?:\/\//)) {
    return `https://${url}`;
  }

  return url;
};

export default getSiteUrl;
